import React, {useEffect, useRef, useState} from 'react'

import {messages} from "../../../helpers/messages";
import {transactionsService} from "../../../services/transactions-service";
import LoaderAside from "./Loader/LoaderAside";
import ReportModal from "../../utilites/ReportModal/ReportModal";

import TimeIcon from '../../../assets/icons/time.svg'
import moment from "moment";
import {DSelect, HCheckbox, HDatePicker, HookForm} from "../../../validation/HForm";
import ReactModal from "react-modal";
import CrossIcon from "../../../assets/icons/cross.svg";
import {monitoringOfBalancesScheme} from "../../../validation/scheme/reportScheme";
import {reportService} from "../../../services/report-service";
import {
  generatePrintedForm,
  getUserFromLocalStorage,
  permissionsAccess
} from "../../../helpers/common";
import {cashBoxService} from "../../../services/cashbox-service";
import {listRoles} from "../../../helpers/data-constants";
import Loader from "../../utilites/ReportModal/LoaderMB";
import {useDispatch, useSelector} from "react-redux";
import {getAvailableCashboxes} from "../../../redux/actions/dashboardAction";
import {addRemoteUser, isModalRemoteReportsModal, removeRemoteUser} from "../../../redux/actions/remotelyReportsAction";
import Select from "react-select";
import {getCashbox} from "../../../redux/actions/handbookAction";

const ReportsAside = ({
                        cashBoxIds,
                        startDate,
                        endDate,
                        rerender,
                        cash,
                        cashBox,
                        successRolesAllCash,
                        branchDirector,
                        availableDepartments
                      }) => {

  const [state, setState] = useState({
    period: {},
    loading: false,
    turnover: false,
    monitoringOfBalances: false,
  })

  const [allBranches, setAllBranches] = useState({})
  const [buttonName, setButtonName] = useState('')
  const {accessFeatures} = useSelector(({user}) => user)
  const {cashbox} = useSelector(({handbook}) => handbook);
  const {remotelyReports, remoteCashBoxId, remoteUserId} = useSelector(({remotelyReports}) => remotelyReports)
  const {cashboxes} = useSelector(({dashboard}) => dashboard);
  const selectUserIdRef = useRef(null);

  const [cashBoxes, setCashBoxes] = useState([])
  const [goodsSpecialists, setGoodsSpecialists] = useState([])
  const userInfo = getUserFromLocalStorage()
  const dispatch = useDispatch()
  const allBranchesAccess = permissionsAccess("action.transaction.revert")
  const branchDirectorAccess = permissionsAccess("action.transaction.revert")
    && permissionsAccess("action.deal.transfer.withdrawal");

  useEffect(() => {
    getTransactionPeriod();
  }, [startDate, endDate, cashBoxIds, rerender, cash, cashBox]);

  useEffect(() => {
    dispatch(getAvailableCashboxes())
  }, [remotelyReports, dispatch])

  useEffect(() => {
    if (cashboxes.length) {
      const actualCashBoxes = cashboxes.map((department) => ({
        value: department.id,
        label: department.name
      }));
      setCashBoxes(actualCashBoxes)
    }
  }, [cashboxes])

  useEffect(() => {
    if (cashbox?.goodsSpecialists) {
      const allGoodsSpecialists = cashbox.goodsSpecialists?.map((goodsSpecialist) => ({
        value: goodsSpecialist.id,
        label: goodsSpecialist.fullName
      }))
      setGoodsSpecialists(allGoodsSpecialists)
    }
  }, [cashbox])

  const error = (err) => {
    if (err.response) {
      let errorData = err.response.data
      let commonError = messages["0"]
      if (errorData.errorCode) {
        commonError = messages[errorData.errorCode]
      }
      setState(prev => ({
        ...prev,
        loading: false,
        error: commonError
      }))
    }
  }

  const changeModalState = (name, value) => {
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getAllBranches = () => {
    setState(prev => ({
      ...prev,
      loading: true,
    }))
    changeModalState('monitoringOfBalances', true)
    if (allBranchesAccess || branchDirectorAccess) {
      cashBoxService.getAllBranches({"directorId": userInfo.id}).then((response) => {
        setAllBranches(
          response.data.branchInfos.map((v) => ({
            value: v.branchId,
            label: v.branchName
          })),
        );
        setState(prev => ({
          ...prev,
          loading: false,
        }))
      }).catch(error)
    }
  }

  const handleChangeCashBox = (selectedCashBox) => {
    selectUserIdRef.current.select.clearValue()
    dispatch(getCashbox({id: selectedCashBox.value}))
    dispatch(addRemoteUser({remoteCashBoxId: selectedCashBox, remoteUserId: null}))
  }
  const handleChangeGoodsSpecialist = (selectedGoodsSpecialist) => {
    dispatch(addRemoteUser({remoteCashBoxId: remoteCashBoxId, remoteUserId: selectedGoodsSpecialist}))
  }

  const getTransactionPeriod = () => {
    setState(prev => ({
      ...prev,
      loading: true
    }))
    let data = {
      cashBoxIds: cashBoxIds,
      startDate: startDate ? startDate.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
      endDate: endDate ? endDate.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
      cash
    }
    if (successRolesAllCash && cashBox.length === 0) {
      delete data.cashBoxIds
    }
    if (branchDirector && cashBoxIds.length === 0) {
      data.cashBoxIds = availableDepartments
    }
    transactionsService.getTransactionPeriod(data).then(response => {
      setState(prev => ({
        ...prev,
        period: response.data,
        loading: false
      }))
    }).catch(error)
  }

  const onSubmit = (data) => {

    const payload = buttonName === 'save' ?
      {"branches": data.allBranches ? allBranches.map(v => v.value).join(',') : `${data?.branch.value}`}
      : {"branches": data.allBranches ? allBranches.map(v => v.value).join(',') : `${data?.branch.value}`, 'pdf': true}

    reportService.generateReport('CASH_BALANCES', payload).then(({data}) => {
      const fileType = buttonName === 'save' ? '.xlsx' : '.pdf'
      const filename = 'CASH_BALANCES_' + moment(data.date).format('DD.MM.YYYY') + fileType;
      if (buttonName === 'save') {
        generatePrintedForm(data, filename, 'xlsx')
        changeModalState('monitoringOfBalances', false)
      }
      if (buttonName === 'watch') {
        generatePrintedForm(data, filename, 'pdf')
      }
    }).catch(error)
  };

  const preventOpenCalendar = e => e.preventDefault()

  return (
    <div className="content-inner-data-aside">
      {(accessFeatures['report.remotely_reports'] && permissionsAccess("action.report.generate.remotely")) && (
         remotelyReports ? (<div className="content-card-row ">
              <button className="button-icontrigger-accent button-aside button-primary"
                      onClick={() => {dispatch(removeRemoteUser())}}>
                <span className="icon"> <CrossIcon/> </span>
                <span>Отмена</span>
              </button>
            </div>) :
            (<div className="content-card-row">
              <button className="button-icontrigger-accent button-aside button-primary"
                      onClick={() => {dispatch(isModalRemoteReportsModal())}}>
                <span>Снять отчеты за другого пользователя</span>
              </button>
            </div>)

      )}

      {remotelyReports && (
        <div className="form-element">
          <div className="form-element-data combobox">
            <Select
              h="true"
              options={cashBoxes}
              placeholder="Выберите подразделение"
              onChange={handleChangeCashBox}
              defaultValue={remoteCashBoxId}

            />
          </div>
          <div className="form-element-data combobox">
            <Select
              h="true"
              ref={selectUserIdRef}
              options={goodsSpecialists}
              placeholder="Выберите товароведа"
              onChange={handleChangeGoodsSpecialist}
              defaultValue={remoteUserId}
            />
          </div>
        </div>
      )}
      <div className="content-card-row-title">
        <h3>Остаток в кассе</h3>
      </div>
      {state.loading ? <LoaderAside/> : <div className="content-card-row">
        <dl className="dl-horizontal dl-big">
          <dt>Начало периода, BYN</dt>
          <dd>{state.period.startOfPeriod}</dd>
        </dl>
        <dl className="dl-horizontal dl-big">
          <dt>Конец периода, BYN</dt>
          <dd>{state.period.endOfPeriod}</dd>
        </dl>
        <dl className="dl-horizontal dl-big">
          <dt>Клиентов за период</dt>
          <dd>{state.period.clients}</dd>
        </dl>

      </div>}
      <div className="content-card-row">
        <button className="button-icontrigger-accent button-aside"
                onClick={() => {changeModalState('turnover', true)}}>
          <span className="icon">
            <TimeIcon/>
          </span>
          <span>Закрыть кассу-день</span>
        </button>
      </div>
      {accessFeatures['report.cash_balances'] && permissionsAccess("action.report.generate.cash_balances") && (
        <div className="content-card-row">
          <button className="button-icontrigger-accent button-aside" onClick={getAllBranches}>
            <span>Мониторинг остатков ДС</span>
          </button>
        </div>)}
      <ReportModal
        open={state.turnover}
        onClose={() => { changeModalState('turnover', false) }}
        dateRange={false}
        type={"CASH_TURNOVER"}
        title={"Кассовые обороты за день"}
        documentType={"xlsx"}
      />
      <ReactModal
        isOpen={state.monitoringOfBalances}
        contentLabel="Modal"
        className="modal-container"
        overlayClassName="modal-overlay">
        <HookForm onSubmit={onSubmit}
                  validationSchema={monitoringOfBalancesScheme}
                  submitOnEnterPress={true}
        >
          <div className="modal-header">
            <h2>Мониторинг остатков денежных средств</h2>
            <button
              className="button-icontrigger modal-closetrigger"
              onClick={() => changeModalState('monitoringOfBalances', false)}>
                            <span className="icon">
                              <CrossIcon/>
                            </span>
            </button>

          </div>
          {state.loading ? (
            <Loader/>
          ) : (
            <div className="modal-body reports-modal-body">
              <div className='form-row'>
                <div className="form-row-item">
                  <div className="form-element">
                    <label className="form-element-label" htmlFor="">
                      Филиал
                    </label>
                    <div className="form-element-data combobox ">
                      <DSelect
                        h="true"
                        name="branch"
                        className="reports-select"
                        options={allBranches}
                        isSearchable={true}
                        isLoading={false}
                        defaultValue={userInfo.roles.includes(listRoles.BRANCH_DIRECTOR) ? allBranches[0] : {
                          value: '',
                          label: ''
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-row-item">
                  <div className="d-flex align-center h-100">
                    <HCheckbox
                      h="true"
                      name="allBranches"
                      label="Все филиалы"
                      className="input"
                      defaultValue={false}
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-row-item">
                  <div className="form-element">
                    <label className="form-element-label" htmlFor="#">
                      Дата
                    </label>
                    <div className="form-element-data date">
                      <HDatePicker
                        h="true"
                        className="input"
                        name="date"
                        id="date"
                        defaultValue={moment().format('YYYY-MM-DD')}
                        readOnly={true}
                        onKeyDown={preventOpenCalendar}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
          <div className="modal-footer reports-modal-footer">
            <button className="button" onClick={() => setButtonName('watch')}>
              Посмотреть
            </button>
            <div>
              <button className="button" onClick={() => setButtonName('save')}>Сохранить</button>
              <button className="button-light" onClick={() => changeModalState('monitoringOfBalances', false)}>
                Отменить
              </button>
            </div>
          </div>
        </HookForm>
      </ReactModal>
    </div>
  )
}

export default ReportsAside
